// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MApb0","home":"styles_home__bUk9Q","ulHolder":"styles_ulHolder__QoR2J"};